import React from "react";
import GlobalModalComponent from "../../../../shared/globalModal/GlobalModalComponent";
import { BalanceModalType } from "../../../../../interface/site.interface";
import styles from "./BalanceModal.module.scss";
import closeIcon from "../../../../../assets/images/modal-icon/CloseIcon.svg";
import successIcon from "../../../../../assets/images/modal-icon/SuccessIcon.svg";
import errorIcon from "../../../../../assets/images/modal-icon/ErrorIcon.svg";
import MainButton from "../../../../shared/button/MainButton";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";

export default function BalanceModal({
  isModalOpen,
  setIsModalOpen,
  isSuccess,
}: BalanceModalType) {
  const { data } = useSelector((state: RootState) => state.translationData);

  return (
    <GlobalModalComponent
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
    >
      <div className={styles.modal_container}>
        <div className={styles.modal_header}>
          <button
            className={styles.close_btn}
            onClick={() => setIsModalOpen(false)}
          >
            <img src={closeIcon} alt="close" />
          </button>
        </div>

        <div className={styles.modal_content}>
          <img src={isSuccess ? successIcon : errorIcon} alt="success" />

          <div className={styles.modal_text_container}>
            <p className={styles.modal_title}>
              {isSuccess
                ? data?.auth_common_balance_increased
                : data?.auth_common_try_again}
            </p>
            <p className={styles.modal_text}>
              {isSuccess
                ? data?.auth_common_thank_you
                : data?.auth_common_fill_all_fields}
            </p>
          </div>

          <MainButton className={styles.back_button} text="Geri dön" />
        </div>
      </div>
    </GlobalModalComponent>
  );
}
